// extracted by mini-css-extract-plugin
module.exports = {"ideas-container-main":"page_ideas-container-main__WK0C5","ideas-container-background":"page_ideas-container-background__ybzl5"};